// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__mE4XB","thumbnail":"BlogCard_thumbnail__t3AoI","details":"BlogCard_details__PzUMA"};